/** RGB offset for lift/gamma/gain style color wheels (shadows / midtones / highlights). */
export interface ColorWheel {
  r: number;
  g: number;
  b: number;
  master: number;
}

export interface HslQualifier {
  enabled: boolean;
  hueMin: number;
  hueMax: number;
  satMin: number;
  satMax: number;
  lumMin: number;
  lumMax: number;
  soft: number;
  invert: boolean;
  /** Qualifier pick color (hex) used as seed for HSL range. */
  pickHex: string;
}

export interface ColorGrade {
  /** Lift / Gamma / Gain style wheels */
  lift: ColorWheel;
  gamma: ColorWheel;
  gain: ColorWheel;
  /** Tonal controls */
  exposure: number;
  contrast: number;
  pivots: number;
  shadows: number;
  midtones: number;
  highlights: number;
  whites: number;
  blacks: number;
  /** Color */
  saturation: number;
  hue: number;
  temperature: number;
  tint: number;
  intensity: number;
  /** Secondary / qualifier */
  qualifier: HslQualifier;
}

export function defaultColorWheel(): ColorWheel {
  return { r: 0, g: 0, b: 0, master: 0 };
}

export function defaultQualifier(): HslQualifier {
  return {
    enabled: false,
    hueMin: 0,
    hueMax: 360,
    satMin: 0,
    satMax: 1,
    lumMin: 0,
    lumMax: 1,
    soft: 0.1,
    invert: false,
    pickHex: '#ffffff',
  };
}

export function defaultColorGrade(): ColorGrade {
  return {
    lift: defaultColorWheel(),
    gamma: defaultColorWheel(),
    gain: defaultColorWheel(),
    exposure: 0,
    contrast: 1,
    pivots: 0.5,
    shadows: 0,
    midtones: 0,
    highlights: 0,
    whites: 0,
    blacks: 0,
    saturation: 1,
    hue: 0,
    temperature: 0,
    tint: 0,
    intensity: 1,
    qualifier: defaultQualifier(),
  };
}
